import { createPortal } from "react-dom";

interface FormTooltipProps {
  name: string;
  message: any;
}

function FormTooltip({ name, message }: FormTooltipProps) {
  const targetElement = document.getElementById(name);

  if (!targetElement || !message) return null;

  return createPortal(
    <div className="d-flex align-items-center" style={{ marginTop: 2, fontSize: 10 }}>
      <div className="d-block font-b3 text-base-grey">{message}</div>
    </div>,
    targetElement,
  );
}

export default FormTooltip;
